import { render, staticRenderFns } from "./AvatarModal.vue?vue&type=template&id=17f9d473&scoped=true&"
import script from "./AvatarModal.vue?vue&type=script&lang=js&"
export * from "./AvatarModal.vue?vue&type=script&lang=js&"
import style0 from "./AvatarModal.vue?vue&type=style&index=0&id=17f9d473&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9d473",
  null
  
)

export default component.exports